<template>
  <v-layout row xs12 justify-center>
    <v-flex xs12>
      <v-layout wrap>
        <v-flex xs12 class=" ma-2">
          <div class="text-sm-left f-20" color="#002d4a">Select student Classes</div>
        </v-flex>
        <v-divider></v-divider>
      </v-layout>
      <!--<v-card class="mt-2` no-shadow card-r">-->
        <!--<v-card-title justify-center xs12>-->

          <!--<v-layout xs12>-->
            <!--<v-flex xs12 class="text-xs-center">-->
                 <!--<h1 class="add-class-header">Select student Classes</h1>-->
            <!--</v-flex>-->
          <!--</v-layout>-->
        <!--</v-card-title>-->
      <v-container fluid grid-list-xl>
        <v-layout row wrap class="">
          <v-flex d-flex lg3 sm3 xs12>
            <v-autocomplete
              v-model="model"
              :items="searchname"
              label="Search Name"
              prepend-icon="person"
              placeholder="Name ">
            </v-autocomplete>
          </v-flex>
          <v-flex d-flex lg3 sm3 xs12>
            <v-autocomplete
              v-model="model"
              :items="classname"
              prepend-icon="fas fa-tachometer-alt"
              label="Select class"
              placeholder="class name ">
            </v-autocomplete>
          </v-flex>
          <v-flex d-flex lg3 sm3 xs12>
            <v-menu
              ref="menu1"
              v-model="menu1"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="dateFormatted"
                label="Select Date"
                persistent-hint
                placeholder="dd/mm/yyyy"
                prepend-icon="event"
              ></v-text-field>
              <v-date-picker v-model="date" no-title @input="menu1 = false"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex d-flex lg3 sm3 xs12>
            <v-select
              :items="timeslot"
              class="input-group--focused"
              prepend-icon="alarm"
              placeholder="select your time"
              label="Starting Time"
            ></v-select>          </v-flex>
          <v-flex d-flex lg3 sm3 xs12>
            <v-btn  larg depressed class="no-shadow card-r ml-4 mr-4" color="primary">book class</v-btn>
          </v-flex>
        </v-layout>
      </v-container>
        <v-card class="combo-vcard mt-3 card-r no-shadow">
          <v-divider ></v-divider>
          <v-layout xs12>

            <v-flex xs6 offset-xs0 >
              <!--<v-card class="no-shadow card-r">-->
                <!--<v-list three-line>-->
                  <!--<template v-for="(item, index) in items">-->
                    <!--<v-subheader class="justify-center"-->
                                 <!--v-if="item.header"-->
                                 <!--:key="item.header"-->
                    <!--&gt;-->
                      <!--{{ item.header }}-->
                    <!--</v-subheader>-->

                    <!--<v-divider-->
                      <!--v-else-if="item.divider"-->
                      <!--:inset="item.inset"-->
                      <!--:key="index"-->
                    <!--&gt;</v-divider>-->

                    <!--<v-list-tile-->
                      <!--v-else-->
                      <!--:key="item.title"-->
                      <!--avatar-->
                      <!--@click=""-->
                    <!--&gt;-->
                      <!--<v-list-tile-avatar>-->
                        <!--&lt;!&ndash;<img :src="item.avatar">&ndash;&gt;-->
                        <!--<v-avatar color="blue-grey">-->
                          <!--<v-icon dark>account_circle</v-icon>-->
                        <!--</v-avatar>-->
                      <!--</v-list-tile-avatar>-->

                      <!--<v-list-tile-content>-->
                        <!--<v-list-tile-title v-html="item.title1"></v-list-tile-title>-->
                        <!--<v-list-tile-sub-title v-html="item.subtitle"></v-list-tile-sub-title>-->
                      <!--</v-list-tile-content>-->
                      <!--<v-flex  xs3 offset-xs0 class="ml-3 mr-2">-->
                        <!--<v-btn class="text-xs-right" right outline small color="blue">cancel</v-btn>-->
                        <!--<v-btn class="text-xs-right" right outline small color="blue">view</v-btn>-->
                      <!--</v-flex>-->
                    <!--</v-list-tile>-->
                  <!--</template>-->
                <!--</v-list>-->
              <!--</v-card>-->
            </v-flex>


            <!--<v-divider-->
              <!--inset-->
              <!--vertical-->
            <!--&gt;</v-divider>-->
            <v-flex xs6 offset-xs0>
              <!--<v-card flat class="content-card">-->
              <!--<v-card-title primary-title>-->
              <!--<v-layout xs12>-->
              <!--<v-flex xs2 justify-center>-->
              <!--<v-icon  class="mt-4 text-xs-left add-class-icon left">far fa-user-circle</v-icon>-->
              <!--</v-flex>-->
              <!--<v-flex xs8>-->
              <!--<h3 class="left" >Student Name</h3><br><br>-->
              <!--<p class="pr-2 " >Lorem ipsum dolor sit ametLorem ipsum dolor sit amet</p>-->
              <!--<span class="left ">45min</span>-->
              <!--</v-flex>-->
              <!--<v-flex xs4>-->
              <!--<v-btn class=" addclass-btn " >Change Time</v-btn><br>-->
              <!--<v-btn class=" addclass-btn">Cancel</v-btn>-->
              <!--</v-flex>-->
              <!--</v-layout>-->
              <!--</v-card-title>-->
              <!--</v-card>-->
              <!--<v-card class="no-shadow card-r">-->
                <!--<v-list three-line>-->
                  <!--<template v-for="(item, index) in items">-->
                    <!--<v-subheader class="justify-center"-->
                                 <!--v-if="item.header"-->
                                 <!--:key="item.header"-->
                    <!--&gt;-->
                      <!--{{ item.header }}-->
                    <!--</v-subheader>-->

                    <!--<v-divider-->
                      <!--v-else-if="item.divider"-->
                      <!--:inset="item.inset"-->
                      <!--:key="index"-->
                    <!--&gt;</v-divider>-->

                    <!--<v-list-tile-->
                      <!--v-else-->
                      <!--:key="item.title"-->
                      <!--avatar-->
                      <!--@click=""-->
                    <!--&gt;-->
                      <!--<v-list-tile-avatar>-->
                        <!--<img :src="item.avatar">-->
                        <!--&lt;!&ndash;<v-avatar color="blue-grey">&ndash;&gt;-->
                        <!--&lt;!&ndash;<v-icon dark>account_circle</v-icon>&ndash;&gt;-->
                        <!--&lt;!&ndash;</v-avatar>&ndash;&gt;-->
                      <!--</v-list-tile-avatar>-->

                      <!--<v-list-tile-content>-->
                        <!--<v-list-tile-title v-html="item.title1"></v-list-tile-title>-->
                        <!--<v-list-tile-sub-title v-html="item.subtitle"></v-list-tile-sub-title>-->
                      <!--</v-list-tile-content>-->
                      <!--<v-btn-->
                        <!--v-show="!seen" v-on:click='seen = !seen'-->
                        <!--outline small color="blue">cancel</v-btn>-->
                      <!--<v-btn-->
                        <!--v-show="seen" v-on:click='seen = !seen'-->
                        <!--outline small color="blue">view</v-btn>-->
                    <!--</v-list-tile>-->
                  <!--</template>-->
                <!--</v-list>-->
              <!--</v-card>-->
            </v-flex>
          </v-layout>

        </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
  /* eslint-disable */
  export default {
    data () {
      return {
        seen: true,
        time: null,
        menu1: false,
        modal2: false,
        menu2: false,
        timeslot: ["07:00 am", "08:00 am" , "09:00 am", "10:00 am" ,"11:00 am", "12:00 pm", "01:00 pm", "02:00 pm", "03:00 pm", "04:00 pm", "05:00 pm", "06:00 pm"],
        items: [
          {
            avatar: 'https://cdn.vuetifyjs.com/images/lists/1.jpg',
            avatar1: 'https://cdn.vuetifyjs.com/images/lists/1.jpg',
            title1: 'Class title',
            title: 'Not Booked',
            subtitle: "<span class='text--primary'>DATE & TIME </span> &mdash; some describtions for this class or somthig..."
          },
          { divider: true, inset: true },
          {
            avatar: 'https://cdn.vuetifyjs.com/images/lists/2.jpg',
            title1: 'Class title',
            title: 'Not Booked',
            subtitle: "<span class='text--primary'>DATE & TIME </span> &mdash; some describtions for this class or somthig..."
          },
          { divider: true, inset: true },
          {
            avatar: 'https://cdn.vuetifyjs.com/images/lists/3.jpg',
            title1: 'Class title',
            title: 'Not Booked',
            subtitle: "<span class='text--primary'>DATE & TIME </span> &mdash; some describtions for this class or somthig..."
          },
          { divider: true, inset: true },
          {
            avatar: 'https://cdn.vuetifyjs.com/images/lists/4.jpg',
            title1: 'Class title',
            title: 'Not Booked',
            subtitle: "<span class='text--primary'>DATE & TIME </span> &mdash; some describtions for this class or somthig...?"
          },
          { divider: true, inset: true },
          {
            avatar: 'https://cdn.vuetifyjs.com/images/lists/5.jpg',
            title1: 'Class title',
            title: 'Not Booked',
            subtitle: "<span class='text--primary'>DATE & TIME </span> &mdash; some describtions for this class or somthig..."
          }
        ],
        classname: ['Class title 1' , 'Class title 2' , 'Class title 3' , 'Class title 4' , 'Class title 5' , 'Class title 6' , ' Class title 7'],
        isEditing: true,
        model: null,
        searchname: [
          'Nayanan ', 'Danny', 'lavan', 'sanjeeven','voranzo', 'sivarubini' , 'das', 'jerushan' , 'thilan'
        ]
      }
    }
  }
</script>
<style>
.add-class-icon{
  color: #0080c2 !important;

}
.add-class-header{
  color: #0067b1;
}
.addclass-btn{
  width: 100% !important;
  background-color: #0097cf !important;
  color: #fff !important;
  -webkit-box-shadow: 10px 7px 17px -5px rgba(194,194,194,1);
-moz-box-shadow: 10px 7px 17px -5px rgba(194,194,194,1);
box-shadow: 10px 7px 17px -5px rgba(194,194,194,1);
  border-radius: 5px;
}
.combo-vcard{
  border-top: 1px solid #ededed !important;
}
.combo-vcard .fa-caret-down:before{
  color:#0069b3;
}
.content-card p{
 color: #adadad;
}
.content-card h3{
 color: #0080c2;
}
.content-card span{
 color: #adadad;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/AddClasses.vue